// SA-8637: Sentry loaded from CDN (see src/index.html + src/types/sentry-cdn.d.ts).

/**
 * Report an error to Sentry with consistent tagging.
 * @param error The error to report
 * @param context A short label identifying where the error originated (e.g. 'auth.cognitoLogin', 'effect.loadMessages')
 * @param extra Optional extra data to attach to the Sentry event
 */
export function reportError(
  error: unknown,
  context: string,
  extra?: Record<string, any>
): void {
  // SA-8637: defensive guard. `Sentry` is populated by the CDN <script> tag
  // in index.html. If the CDN failed to load (network / blocked / CSP), OR
  // if we're in a Jest test environment without the global installed, we
  // fall back to console.error rather than crashing the calling flow.
  if (typeof Sentry === 'undefined') {
    console.error('[sentry.utils] Sentry not loaded:', error, context, extra);
    return;
  }
  const [source] = context.split('.');
  Sentry.captureException(error, {
    tags: {
      source,
      context
    },
    extra
  });
}
